import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export function getSchema(t: TFunction<'translation'>) {
  return yup.object().shape({
    email: yup
      .string()
      .email(t('enter-a-valid-email'))
      .required(t('something-is-required', { something: t('email') })),
    displayName: yup.string().required(t('something-is-required', { something: t('name') })),
    phoneNumber: yup.string().required(t('something-is-required', { something: t('phone-number') })),
    presidentEmail: yup
      .string()
      .email(t('enter-a-valid-email'))
      .required(t('something-is-required', { something: t('email') })),
    presidentName: yup.string().required(t('something-is-required', { something: t('name') })),
    presidentPhoneNumber: yup.string().required(t('something-is-required', { something: t('phone-number') })),
    address: yup.string().required(t('something-is-required', { something: t('address') })),
    zipCode: yup.string().required(t('something-is-required', { something: t('zip-code') })),
    country: yup.string().required(t('something-is-required', { something: t('country') })),
    organizationName: yup.string().required(t('something-is-required', { something: t('name-of-oc') })),
    position: yup.string(),
    bankAccountPurpose: yup.string().required(t('something-is-required', { something: t('bank-account-purpose') })),
    bankAccountName: yup.string().required(t('something-is-required', { something: t('name-of-account') })),
    bankName: yup.string().required(t('something-is-required', { something: t('bank-name') })),
    iban: yup.string().required(t('something-is-required', { something: 'IBAN' })),
    bic: yup.string().required(t('something-is-required', { something: 'BIC' })),
    bankAccountPurpose2: yup.string().required(t('something-is-required', { something: t('bank-account-purpose') })),
    bankAccountName2: yup.string().required(t('something-is-required', { something: t('name-of-account') })),
    bankName2: yup.string().required(t('something-is-required', { something: t('bank-name') })),
    iban2: yup.string().required(t('something-is-required', { something: 'IBAN' })),
    bic2: yup.string().required(t('something-is-required', { something: 'BIC' })),
  });
}
